import React, {useContext} from "react";
import { GlobalContext } from "../context/GlobalState";

const Done = () => {
    const {movieWatched} = useContext(GlobalContext);
    const {serieWatched} = useContext(GlobalContext);
    const {bookRead} = useContext(GlobalContext);

    const {removeBookFromDone, removeMovieFromDone, removeSerieFromDone} = useContext(GlobalContext);

    return (
        <div className="doneList">
            <h1>Watched movies</h1>
            {movieWatched.length > 0 ? (
                <div className="list">
                {movieWatched.map(movie => (
                        <div className="cardContainer">
                            <img src={"https://image.tmdb.org/t/p/w500" + movie.poster_path} alt=""/>
                            <h2 data-id={movie.id}>{movie.title}</h2>
                            <button className="btn-warning" onClick={() => removeMovieFromDone(movie.id)}>Remove from Watched</button>
                        </div>    
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No watched series. Go watch some!</h2>
            )}

            <h1>Watched series</h1>
            {serieWatched.length > 0 ? (
                <div className="list">
                {serieWatched.map(serie => (
                        <div className="cardContainer">
                            <img src={"https://image.tmdb.org/t/p/w500" + serie.poster_path} alt=""/>
                            <h2 data-id={serie.id}>{serie.name}</h2>
                            <button className="btn-warning" onClick={() => removeSerieFromDone(serie.id)}>Remove from Watched</button>
                        </div>    
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No watched series. Go watch some!</h2>
            )}

            <h1>Read Books</h1>
            {bookRead.length > 0 ? (
                <div className="list">
                    {bookRead.map(book => (
                        <div className="cardContainer">
                            <img src={book.volumeInfo.imageLinks.thumbnail} alt="" />
                            <h2>{book.volumeInfo.title}</h2>
                            <button className="btn-warning" onClick={() => removeBookFromDone(book.id)}>Remove from Read</button>
                        </div>    
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No read books. Go read some!</h2>
            )}
        </div>
    )
}

export default Done;